const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const DataUnavailableMessage = ({ selectedMonth,customMessage }) => {
  return (
    <p className="message">
      {customMessage ? (
        customMessage
      ) : (
        <>
          The requested data for <b>{months[selectedMonth?.split('-')[1] - 1]} {selectedMonth?.split('-')[0]}</b> is currently unavailable.
        </>
      )}
    </p>
  );
};

export default DataUnavailableMessage;
